export const Modules = {
    STOW: 'STOW',
    STAGE: 'STAGE'
};